import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import Flex from "../../../DefaultStyles/Flex";
import LineBox from "../../../DefaultStyles/LineBox";
import { OptionType } from "../../../Filters/DropDown";
import {
  AxixTitle,
  ChartContainer,
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "../UserBoard/IndateSection";
import Chart from "react-apexcharts";
import DashBoardToggleBtn from "../DashBoardToggleBtn";
import useIsMobile from "../../../../hooks/useIsMobile";
import PayHistorySectionFilter from "./PayHistorySection/PayHistorySectionFilter";
import Blank from "../../../DefaultStyles/Blank";
import { atom, useRecoilValue } from "recoil";
import { mgLogType } from "../../../../AdminApi/commFunc";

interface PayHistorySectionProps extends IndateSectionProps {}

export interface ISeries {
  name: string;
  data: number[];
}

export const payHistoryFilterState = atom<OptionType[]>({
  key: "payHistoryFilterState",
  default: [],
});

export default function PayHistorySection({
  filter,
  setFilter,
}: PayHistorySectionProps) {
  const isMobile = useIsMobile();

  const [detailList, setDetailList] = useState("");

  const typeValue = useRecoilValue(payHistoryFilterState);
  const [series, setSeries] = useState<ISeries[]>([]);
  const [date, setDate] = useState<string[]>([]);

  // console.log("❤️", typeValue);

  console.log(detailList);

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/total?type=pay&subtype=mglog&startdate=${dayjs(filter.startDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&enddate=${dayjs(filter.endDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&filter=day` +
          (detailList !== "" ? `&detail=${detailList}` : ``)
        : undefined,
  });

  const optionList = mgLogType();

  useEffect(() => {
    let series: any[] = [];
    let date: string[] = [];

    if (response?.status === 200) {
      const objByDetail = response.data.reduce((group: any, product: any) => {
        const { detail } = product;

        group[detail] = group[detail] ?? [];
        group[detail].push(product);

        return group;
      }, {});

      const arrByDetail = Object.entries(objByDetail);

      for (let i = 0; i < arrByDetail.length; i++) {
        const element = arrByDetail[i] as any[];
        const elementData = element[1];

        let list = [];

        for (let j = 0; j < elementData.length; j++) {
          const el = elementData[j];

          list.push(filter?.isAccum ? el.data.total ?? 0 : el.data.sum ?? 0);
        }

        const mgLogLabel = mgLogType().find((d) => {
          return d.value === element[0];
        });

        if (mgLogLabel && mgLogLabel?.category !== "") {
          series.push({
            data: list.reverse(),
            name: mgLogLabel?.label,
          });
        } else {
          console.log(element[0]);
        }
      }

      for (let i = 0; i < response?.data.length; i++) {
        const element = response?.data[i];

        date.push(dayjs(element.date).add(-1, "day").format("YYYY-MM-DD"));
      }

      const set = new Set(date.reverse());
      const uniqueDate = [...set];

      setDate(uniqueDate);
      setSeries(series);
    }
  }, [response, filter.isAccum]);

  useEffect(() => {
    const arr: string[] = [];

    for (let i = 0; i < typeValue.length; i++) {
      const element = typeValue[i];

      arr.push(`"${element?.value}"`);
    }

    setDetailList(arr.toString());
  }, [typeValue]);

  useEffect(() => {
    if (detailList === "") {
      setSeries([]);
    }
  }, [detailList]);

  // useEffect(() => {}, [series]);

  console.log(series);

  return (
    <>
      <PayHistorySectionFilter optionList={optionList} />
      <Blank blankHeight={40} />

      <DashBoardSectionTitleContainer>
        <Flex gapSize={10} style={{ alignItems: "center" }}>
          <DashBoardSectionTitle>거래 내역</DashBoardSectionTitle>
        </Flex>

        <DashBoardToggleBtn
          btnTextArray={["일별", "누적"]}
          filter={filter}
          setFilter={setFilter}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DashBoardViewDate isMobile={isMobile}>
          조회 기간 : {filter.startDate} ~ {filter.endDate}
        </DashBoardViewDate>

        <ChartContainer>
          <AxixTitle>원</AxixTitle>

          <Chart
            type="bar"
            height={300}
            series={series ?? []}
            options={{
              chart: {
                id: "payhistoryChart",
                type: "bar",
                stacked: true,
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: false,
                },
              },
              // responsive: [
              //   {
              //     breakpoint: 480,
              //     options: {
              //       legend: {
              //         position: "bottom",
              //         offsetX: -10,
              //         offsetY: 0,
              //       },
              //     },
              //   },
              // ],
              plotOptions: {
                bar: {
                  horizontal: false,
                  borderRadius: 10,
                  dataLabels: {
                    position: "top",
                    hideOverflowingLabels: false,
                  },
                },
              },
              dataLabels: {
                enabled: true,
                formatter: (value, { seriesIndex, dataPointIndex, w }) => {
                  if (seriesIndex === w.globals.series.length - 1) {
                    return getThousandComma(
                      w.globals.stackedSeriesTotals[dataPointIndex] ?? 0
                    );
                  } else {
                    return "";
                  }
                },

                offsetY: -20,
                style: {
                  fontSize: "12px",
                  colors: ["#304758"],
                },
              },
              xaxis: {
                labels: {
                  formatter: (value) => {
                    return dayjs(value).format("M/DD (dd)");
                  },
                },

                categories: date,
                position: "left",
              },
              yaxis: {
                labels: {
                  formatter: (value) => {
                    return getThousandComma(value ?? 0);
                  },
                },
              },
              legend: {
                position: "bottom",
                offsetY: 8,
                fontFamily:
                  "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                markers: {
                  width: 10,
                  height: 10,
                  offsetX: -4,
                  radius: 10,
                },
                fontSize: "13px",
                fontWeight: 500,
                itemMargin: {
                  horizontal: 16,
                },
                onItemClick: {
                  toggleDataSeries: detailList !== "" ? false : true,
                },
              },
              fill: {
                opacity: 1,
              },
              tooltip: {
                x: {
                  formatter: (value) => {
                    return dayjs(value).format("M/DD (dd)");
                  },
                },
                y: {
                  formatter: (value) => getThousandComma(value ?? 0) + "원",
                },
              },
            }}
          />

          <AxixTitle isX>날짜</AxixTitle>
        </ChartContainer>
      </LineBox>
    </>
  );
}
